export enum ECardType {
	PATIENT_E_CARD = 'patientECard',
	HEALTH_DOCUMENTATION = 'healthDocumentation',
}
